import clsx from 'clsx'
import { Audio, Discuss, Oval } from 'react-loader-spinner'
import { useEffect, useState } from 'react'


const SectionPreloader =({show, color='#000', txt="LOADIN DATA.."}) => {
  const [option, setOption] = useState(0);
  useEffect(()=> {
    setOption(Math.floor(Math.random()*3))
  }, [])

  return <div className={clsx("section_preloader", show===2 ? 'longer' : 'show')}>
    {
      option ===0 ? <Audio
        height="60"
        width="60"
        color={color}
        ariaLabel="audio-loading"
        wrapperStyle={{}}
        wrapperClass="wrapper-class"
        visible={true}
      /> : option ===1 ? <Discuss
        visible={true}
        height="60"
        width="60"
        ariaLabel="comment-loading"
        wrapperStyle={{}}
        wrapperClass="comment-wrapper"
        colors={[color, color]}
      /> :
        <Oval
          height="60"
          width="60"
          color={color}
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
          ariaLabel='oval-loading'
          secondaryColor="#444444"
          strokeWidth={2}
          strokeWidthSecondary={2}
        />
    }
    <span style={{fontSize:'0.8rem', letterSpacing:3,margin:2}}>{txt}</span>
  </div>
}

export default SectionPreloader;
